import * as types from "../actions/index";
export default function(state = { state: false, label: "Loading" }, action) {
  switch (action.type) {
    case types.SET_NOTIFICATION_LOADER:
      return { ...state, ...action.payload };
    // no default
  }
  return state;
}
